import {
  DWELLER_USER_ROLE,
  LANDLORD_USER_ROLE,
} from '../../../../constants/user'

export const TENANTS_ROLE_API_PARAMS = {
  additionalParams: {
    role: [DWELLER_USER_ROLE],
  },
}

export const LANDLORDS_ROLE_API_PARAMS = {
  additionalParams: {
    role: [LANDLORD_USER_ROLE],
  },
}
